import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DocumentCalculationMethodEnum } from '@zaoblako/shared/modules/document/enums/document.calculation.method.enum';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
  standalone: true,
  selector: 'crm-reference-calc-method-select',
  templateUrl: './reference-calc-method-select.component.html',
  imports: [CommonModule, SelectButtonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReferenceCalcMethodSelectComponent {
  @Input() public calcMethod: DocumentCalculationMethodEnum;
  @Output() public calcMethodChange = new EventEmitter<DocumentCalculationMethodEnum>();

  public periodOptions: { label: string; value: DocumentCalculationMethodEnum }[] = [
    { label: 'Кассовый', value: DocumentCalculationMethodEnum.KASS },
    { label: 'Начисления', value: DocumentCalculationMethodEnum.SALE }
  ];
}
